import { FFAI_PATH_PREFIX } from 'shared/lib/ffaiSite';

// Websites Genesis publishes besides ff.com. Each one is a root category that
// the page category picker shows as its own first choice, under the site's
// domain, instead of inside FF.COM.
export const SEPARATE_SITES = [
  { path: FFAI_PATH_PREFIX, title: 'FFAI.COM' },
  { path: '/cxc10', title: 'AIXCRYPTO.AI' }
];

// First level of the page category picker: FF.COM (every other root category),
// then one entry per separate site whose root category exists.
export default function getSiteCategories(rootCategories) {
  const roots = rootCategories || [];
  const sitePaths = SEPARATE_SITES.map(site => site.path);
  const sites = SEPARATE_SITES
    .map((site) => {
      const category = roots.find(c => c.path === site.path);
      return category && { ...category, title: site.title };
    })
    .filter(Boolean);

  return [
    {
      title: 'FF.COM',
      path: '',
      children: roots.filter(c => !sitePaths.includes(c.path)),
      _id: 'is-root'
    },
    ...sites
  ];
}

// The option a picker level is on: the one whose path is the selected path or
// its longest ancestor ('' is the ancestor of every path). Matching whole paths,
// not the Nth path segment, lets one level hold options of different depths:
// FF.COM is '', FFAI.COM is '/ffai'.
export const findActiveCategory = (options, path) => (options || [])
  .filter(o => path === o.path || path.startsWith(`${o.path}/`))
  .sort((a, b) => b.path.length - a.path.length)[0];

// The category with exactly this path anywhere in the tree, or null. Create links
// may name the category (?category=/us/events); AIXC paths may be written /aixc.
export const findCategoryByPath = (categories, rawPath) => {
  let path = String(rawPath || '').trim().replace(/\/+$/, '');
  if (!path) return null;
  if (!path.startsWith('/')) path = `/${path}`;
  path = path.replace(/^\/aixc(\/|$)/i, '/cxc10$1');
  const search = (list) => {
    for (const c of list || []) {
      if (c.path === path) return c;
      const inside = search(c.children);
      if (inside) return inside;
    }
    return null;
  };
  return search(categories);
};
